import {action, makeObservable, observable} from "mobx";

export class MarketingAlertStore {
  showAgentSelection = false;
  showMissingSegment = false;
  showRedirectSuccess = false;
  showRedirectError = false;

  constructor() {
    makeObservable(this, {
      showAgentSelection: observable,
      showMissingSegment: observable,
      showRedirectSuccess: observable,
      showRedirectError: observable,
      show: action,
      hide: action,
      onTriggerHide: action,
    });
  }

  show(alert) {
    this[alert] = true;
    this.onTriggerHide(alert);
  }

  hide(alert) {
    this[alert] = false;
  }
  
  onTriggerHide(alert){
    setTimeout(() => this.hide(alert), 2000);
  }
}
